<div class="flex flex-col">
  <div class="flex items-center gap-2 mb-2">
    <p-checkbox [(ngModel)]="showExpiredAndInactive" [binary]="true" inputId="showExpired"
      (onChange)="onShowExpiredChange()" />
    <label for="showExpired" class="cursor-pointer">Show Expired and Inactive Programs</label>
  </div>

  <p-splitter [style]="{ height: 'calc(85vh - 160px)' }" layout="vertical" [panelSizes]="[55, 45]"
    styleClass="qb-grid-detail-panel-splitter">
    <ng-template pTemplate>
      <prox-ag-grid [gridOptions]="gridOptions" [rowData]="filteredProgramAccessItems"
        [hasFooter]="false"></prox-ag-grid>
    </ng-template>
    <ng-template pTemplate>
      <div class="qb-grid-detail-panel">
        <!-- Detail Panel -->
        <div *ngIf="selectedItem" class="qb-grid-detail-panel-content">
          <!-- Left: Information Table -->
          <div class="qb-grid-detail-panel-section">
            <div class="qb-grid-detail-panel-header">Information</div>
            <table class="qb-grid-detail-panel-table">
              <tr>
                <td class="qb-grid-detail-panel-label">Account Name</td>
                <td class="qb-grid-detail-panel-value emphasis">{{ accountUser.account.name }}</td>
              </tr>
              <tr>
                <td class="qb-grid-detail-panel-label">Program Name</td>
                <td class="qb-grid-detail-panel-value emphasis">{{ selectedItem.program.name }}</td>
              </tr>
              <tr>
                <td class="qb-grid-detail-panel-label">Description</td>
                <td class="qb-grid-detail-panel-value">{{ selectedItem.program.description || '(none)' }}</td>
              </tr>
              <tr>
                <td class="qb-grid-detail-panel-label">Status</td>
                <td class="qb-grid-detail-panel-value" [style.color]="selectedItem.isExpired ? '#dc2626' : null">{{
                  selectedItem.displayStatus || '(none)' }}</td>
              </tr>
              <tr>
                <td class="qb-grid-detail-panel-label">Program Type</td>
                <td class="qb-grid-detail-panel-value">{{ selectedItem.programType }}</td>
              </tr>
              <tr>
                <td class="qb-grid-detail-panel-label">Start Date Type</td>
                <td class="qb-grid-detail-panel-value">{{ selectedItem.program.programStartDateType.name || '(none)' }}
                </td>
              </tr>
              <tr>
                <td class="qb-grid-detail-panel-label">Start Date</td>
                <td class="qb-grid-detail-panel-value">{{ selectedItem.program.startDate | date:'mediumDate' }}</td>
              </tr>
              <tr>
                <td class="qb-grid-detail-panel-label">Account Admins</td>
                <td class="qb-grid-detail-panel-value">
                  <ng-container *ngIf="selectedItem.adminNames.length === 0">(none assigned)</ng-container>
                  <ng-container *ngIf="selectedItem.adminNames.length > 0">
                    <div *ngFor="let name of selectedItem.adminNames.slice(0, 3)">{{ name }}</div>
                    <div *ngIf="selectedItem.adminNames.length > 3" class="qb-grid-detail-panel-more">
                      ... and {{ selectedItem.adminNames.length - 3 }} more
                    </div>
                  </ng-container>
                </td>
              </tr>
            </table>
            <a class="text-primary cursor-pointer hover:underline mt-2 inline-block" (click)="showProgramNarrative()">
              View Program Narrative
            </a>
          </div>

          <!-- Vertical Rule -->
          <div class="qb-grid-detail-panel-divider"></div>

          <!-- Program User Group Information -->
          <div class="qb-grid-detail-panel-section">
            <div class="qb-grid-detail-panel-header">Program User Group Information</div>
            <table class="qb-grid-detail-panel-table">
              <tr>
                <td class="qb-grid-detail-panel-label">Name</td>
                <td class="qb-grid-detail-panel-value emphasis">{{ selectedItem.programUserGroupName }}</td>
              </tr>
              <tr>
                <td class="qb-grid-detail-panel-label">Status</td>
                <td class="qb-grid-detail-panel-value">{{ selectedItem.programUserGroupStatus || '(none)' }}</td>
              </tr>
              <tr>
                <td class="qb-grid-detail-panel-label">Join Date</td>
                <td class="qb-grid-detail-panel-value">{{ selectedItem.joinDate | date:'mediumDate' }}</td>
              </tr>
              <tr>
                <td class="qb-grid-detail-panel-label">Access</td>
                <td class="qb-grid-detail-panel-value" [style.color]="selectedItem.isExcluded ? '#dc2626' : '#16a34a'">
                  {{ selectedItem.isExcluded ? 'Excluded' : 'Included' }}
                </td>
              </tr>
            </table>
          </div>

          <!-- Vertical Rule -->
          <div *ngIf="selectedItem.isAllowanceProgram" class="qb-grid-detail-panel-divider"></div>

          <!-- Right: Allowance Information (only shown for allowance programs) -->
          <div *ngIf="selectedItem.isAllowanceProgram" class="qb-grid-detail-panel-section">
            <div class="qb-grid-detail-panel-header">Allowance Information</div>
            <table class="qb-grid-detail-panel-table">
              <tr>
                <td class="qb-grid-detail-panel-label">Allowance Amount</td>
                <td class="qb-grid-detail-panel-value mono">{{ formatCurrency(selectedItem.allowanceAmt) }}</td>
              </tr>
              <tr>
                <td class="qb-grid-detail-panel-label">Charged</td>
                <td class="qb-grid-detail-panel-value mono">{{ formatCurrency(selectedItem.chargedAmt) }}</td>
              </tr>
              <tr>
                <td class="qb-grid-detail-panel-label">Adjustments</td>
                <td class="qb-grid-detail-panel-value mono">{{ formatCurrency(selectedItem.adjustmentsAmt) }}</td>
              </tr>
              <tr>
                <td class="qb-grid-detail-panel-label">Program Balance</td>
                <td class="qb-grid-detail-panel-value mono"
                  [class.negative]="selectedItem.programBalanceAmt !== null && selectedItem.programBalanceAmt < 0">
                  {{ formatCurrency(selectedItem.programBalanceAmt) }}
                </td>
              </tr>
              <tr>
                <td class="qb-grid-detail-panel-label">Global Allowance</td>
                <td class="qb-grid-detail-panel-value mono" [class.negative]="selectedItem.globalAllowanceAmt < 0">
                  {{ formatCurrency(selectedItem.globalAllowanceAmt) }}
                </td>
              </tr>
              <tr class="qb-grid-detail-panel-summary-row">
                <td class="qb-grid-detail-panel-label">Available</td>
                <td class="qb-grid-detail-panel-value mono bold"
                  [class.negative]="selectedItem.availableBalanceAmt !== null && selectedItem.availableBalanceAmt < 0">
                  {{ formatCurrency(selectedItem.availableBalanceAmt) }}
                </td>
              </tr>
            </table>
          </div>

          <!-- Vertical Rule -->
          <div *ngIf="selectedItem.isIssuanceProgram" class="qb-grid-detail-panel-divider"></div>

          <!-- Right: Issuance Information (only shown for issuance programs) -->
          <div *ngIf="selectedItem.isIssuanceProgram" class="qb-grid-detail-panel-section">
            <div class="qb-grid-detail-panel-header">Issuance Information</div>
            <table class="qb-grid-detail-panel-table">
              <thead>
                <tr>
                  <th class="qb-grid-detail-panel-col-header">Category</th>
                  <th class="qb-grid-detail-panel-col-header text-right">Min</th>
                  <th class="qb-grid-detail-panel-col-header text-right">Max</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="selectedItem.issuanceDetails.length === 0">
                  <tr>
                    <td class="qb-grid-detail-panel-value" colspan="3">(none)</td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="selectedItem.issuanceDetails.length > 0">
                  <tr *ngFor="let issuance of selectedItem.issuanceDetails">
                    <td class="qb-grid-detail-panel-value">{{ issuance.name }}</td>
                    <td class="qb-grid-detail-panel-value mono text-right">{{ issuance.minQty ?? '-' }}</td>
                    <td class="qb-grid-detail-panel-value mono text-right">{{ issuance.maxQty ?? '-' }}</td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>

          <!-- Vertical Rule -->
          <div *ngIf="selectedItem.accountIssuanceDetails.length > 0" class="qb-grid-detail-panel-divider"></div>

          <!-- Account Issuance Information (only shown if there are account issuances) -->
          <div *ngIf="selectedItem.accountIssuanceDetails.length > 0" class="qb-grid-detail-panel-section">
            <div class="qb-grid-detail-panel-header">Account Issuance Information</div>
            <table class="qb-grid-detail-panel-table">
              <thead>
                <tr>
                  <th class="qb-grid-detail-panel-col-header">Category</th>
                  <th class="qb-grid-detail-panel-col-header text-right"># Days</th>
                  <th class="qb-grid-detail-panel-col-header text-right">Max</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let acctIssuance of selectedItem.accountIssuanceDetails">
                  <td class="qb-grid-detail-panel-value">{{ acctIssuance.name }}</td>
                  <td class="qb-grid-detail-panel-value mono text-right">{{ acctIssuance.timeframeDays }}</td>
                  <td class="qb-grid-detail-panel-value mono text-right">{{ acctIssuance.maxQty }}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
        <div *ngIf="!selectedItem" class="qb-grid-detail-panel-empty">
          Select a program above to see additional details.
        </div>
      </div>
    </ng-template>
  </p-splitter>

  <div class="flex justify-start gap-2 mt-3">
    <p-button label="Close" icon="pi pi-times" (onClick)="close()" />
  </div>
</div>